import React from 'react';

export default function GhostLogo({ size = 32, animated = false, className = '' }) {
  return (
    <div 
      className={`ghost-logo ${animated ? 'animated' : ''} ${className}`}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 100 100" fill="none" width={size} height={size}>
        <defs>
          <filter id="ghostGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          <linearGradient id="ghostGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="50%" stopColor="#16a34a" />
            <stop offset="100%" stopColor="#15803d" />
          </linearGradient>
          <linearGradient id="penGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="100%" stopColor="#15803d" />
          </linearGradient>
          <linearGradient id="notebookGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#334155" />
            <stop offset="100%" stopColor="#1e293b" />
          </linearGradient>
        </defs>
        
        {/* Ghost Body - rounded blob shape */}
        <ellipse 
          cx="50" 
          cy="40" 
          rx="30" 
          ry="26" 
          fill="url(#ghostGradient)"
          filter="url(#ghostGlow)"
        />
        
        {/* Ghost bottom - smooth wavy drips */}
        <path
          d="M20 40 
             C20 55, 25 62, 30 65
             Q33 67, 34 63
             Q35 67, 38 65
             Q41 68, 44 64
             C46 68, 48 75, 50 88
             C50 92, 49 95, 50 92
             C51 88, 52 75, 54 68
             Q57 64, 60 65
             Q63 68, 66 64
             Q68 67, 70 65
             C75 62, 80 55, 80 40"
          fill="url(#ghostGradient)"
          filter="url(#ghostGlow)"
        />
        
        {/* Sparkle particles */}
        <circle cx="52" cy="90" r="1.5" fill="#86efac" opacity="0.9"/>
        <circle cx="48" cy="94" r="1" fill="#86efac" opacity="0.7"/>
        <circle cx="54" cy="96" r="0.8" fill="#86efac" opacity="0.5"/>
        <circle cx="46" cy="88" r="0.8" fill="#86efac" opacity="0.6"/>
        
        {/* Left arm/hand holding pen */}
        <ellipse cx="18" cy="52" rx="6" ry="5" fill="url(#ghostGradient)" filter="url(#ghostGlow)"/>
        
        {/* Pen */}
        <rect x="8" y="38" width="4" height="22" rx="1" fill="url(#penGradient)" transform="rotate(-20 10 49)"/>
        <polygon points="10,62 14,62 12,68" fill="#86efac" transform="rotate(-20 12 65)"/>
        
        {/* Right arm/hand holding notebook */}
        <ellipse cx="82" cy="52" rx="6" ry="5" fill="url(#ghostGradient)" filter="url(#ghostGlow)"/>
        
        {/* Notebook */}
        <rect x="68" y="44" width="18" height="22" rx="2" fill="url(#notebookGradient)" transform="rotate(10 77 55)"/>
        {/* Notebook spiral */}
        <circle cx="70" cy="48" r="1.5" fill="#64748b" transform="rotate(10 77 55)"/>
        <circle cx="70" cy="52" r="1.5" fill="#64748b" transform="rotate(10 77 55)"/>
        <circle cx="70" cy="56" r="1.5" fill="#64748b" transform="rotate(10 77 55)"/>
        <circle cx="70" cy="60" r="1.5" fill="#64748b" transform="rotate(10 77 55)"/>
        <circle cx="70" cy="64" r="1.5" fill="#64748b" transform="rotate(10 77 55)"/>
        
        {/* Glasses */}
        <circle cx="40" cy="40" r="10" fill="none" stroke="#1a1a1a" strokeWidth="2.5"/>
        <circle cx="60" cy="40" r="10" fill="none" stroke="#1a1a1a" strokeWidth="2.5"/>
        {/* Bridge */}
        <line x1="50" y1="38" x2="50" y2="42" stroke="#1a1a1a" strokeWidth="2.5"/>
        {/* Temple arms */}
        <path d="M30 40 Q24 38, 22 34" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round"/>
        <path d="M70 40 Q76 38, 78 34" stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinecap="round"/>
        
        {/* Eyes behind glasses */}
        <circle cx="40" cy="41" r="5" fill="#0f172a"/>
        <circle cx="60" cy="41" r="5" fill="#0f172a"/>
        
        {/* Eye shine */}
        <circle cx="42" cy="39" r="2" fill="#ffffff" opacity="0.9"/>
        <circle cx="62" cy="39" r="2" fill="#ffffff" opacity="0.9"/>
      </svg>
    </div>
  );
}
